import { initialMainState, MainReducerState } from "@globalState/reducers/mainReducer";

export interface GlobalState {
    main: MainReducerState;
}

export const initialState: GlobalState = {
    main: initialMainState
};
